import React from "react";
import { DocumentIcon } from "../../ui/widgets/icons";
import CustomTypography from "../../ui/widgets/typography";
import "./styles.scss";

interface RequiredDocumentItemProps {
  content?: string;
  children?: React.JSX.Element;
}

export const RequiredDocumentItem = ({
  content,
}: RequiredDocumentItemProps): React.JSX.Element => {
  return (
    <CustomTypography className="scd-info-item" variant="body1">
      <DocumentIcon />
      <span className="item-text">{content}</span>
    </CustomTypography>
  );
};
